// extracted by mini-css-extract-plugin
export default {"m":"_6c988e1c8e","title":"bb9c53d64f","feedback_inner_title":"_771274edd8","textarea":"_834a53d795","radio":"b27568dcd0","text":"_07bafc1076"};